import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

export interface WithACLProps<T extends boolean> {
  conditionMet: T
  success: ReactNode
  redirectTo: string
}

export function WithACL<T extends boolean>(props: WithACLProps<T>) {
  if (props.conditionMet) {
    return props.success
  }
  return <Navigate replace to={props.redirectTo} />
}
